// frontend/src/services/gpsService.js
import apiClient from './apiClient';

const toList = (data) => Array.isArray(data) ? data : (data?.results || []);

// ─── Posiciones GPS ───────────────────────────────────────────────────────────

const ubicacionesFlotaActiva = async () => {
  const r = await apiClient.get('ubicaciones-equipos-gps/flota-activa/');
  return toList(r.data);
};

const ubicacionesTodasLasUnidades = async () => {
  const r = await apiClient.get('ubicaciones-equipos-gps/todas-las-unidades/');
  return toList(r.data);
};

const ubicacionEquipo = async (equipoId) => {
  const r = await apiClient.get('ubicaciones-equipos-gps/', { params: { equipo: equipoId } });
  const list = toList(r.data);
  return list.length > 0 ? list[0] : null;
};

const historialEquipo = async (equipoId, desde, hasta) => {
  const params = {};
  if (desde) params.desde = desde;
  if (hasta) params.hasta = hasta;
  const r = await apiClient.get(`ubicaciones-equipos-gps/?equipo=${equipoId}`, { params });
  return toList(r.data);
};

// ─── Conectores GPS ───────────────────────────────────────────────────────────

const listarConectores = async () => {
  const r = await apiClient.get('conectores-gps/?page_size=1000');
  return toList(r.data);
};

const obtenerConector = async (id) => {
  const r = await apiClient.get(`conectores-gps/${id}/`);
  return r.data;
};

const crearConector = async (datos) => {
  const r = await apiClient.post('conectores-gps/', datos);
  return r.data;
};

const actualizarConector = async (id, datos) => {
  const r = await apiClient.patch(`conectores-gps/${id}/`, datos);
  return r.data;
};

const eliminarConector = async (id) => {
  await apiClient.delete(`conectores-gps/${id}/`);
};

// ─── Previsualización ─────────────────────────────────────────────────────────

const previsualizarConector = async (id) => {
  const r = await apiClient.get(`conectores-gps/${id}/previsualizar/`);
  return Array.isArray(r.data) ? r.data : [];
};

// ─── Mapeos GPS ───────────────────────────────────────────────────────────────

const listarMapeos = async (params = {}) => {
  const r = await apiClient.get('mapeos-gps/', { params });
  return toList(r.data);
};

const crearMapeo = async (datos) => {
  const r = await apiClient.post('mapeos-gps/', datos);
  return r.data;
};

const eliminarMapeo = async (id) => {
  await apiClient.delete(`mapeos-gps/${id}/`);
};

// ─── Export ───────────────────────────────────────────────────────────────────

const gpsService = {
  ubicacionesFlotaActiva,
  ubicacionesTodasLasUnidades,
  ubicacionEquipo,
  historialEquipo,
  listarConectores,
  obtenerConector,
  crearConector,
  actualizarConector,
  eliminarConector,
  previsualizarConector,
  listarMapeos,
  crearMapeo,
  eliminarMapeo,
};

export default gpsService;
